export const REPLACE = "REPLACE_CONCEPTS";

export const Replace = (concepts) => ({ 
    type : REPLACE,
    concepts
});